import { render, staticRenderFns } from "./ContaModal.vue?vue&type=template&id=210926e6&"
import script from "./ContaModal.vue?vue&type=script&lang=js&"
export * from "./ContaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports